// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PASSWORD_RESET_CHOOSE_EMAIL = "Obnov si heslo cez email alebo prihlasovacie meno";
export const PASSWORD_RESET_CHOOSE_SMS = "Obnov si heslo cez telef\u00f3n (mus\u00ed\u0161 ma\u0165 overen\u00e9 \u010d\u00edslo na kon\u00edku)";
export const PASSWORD_RESET_DID_YOU_FORGET_PASSWORD = "Zabudla si heslo?";
